module.exports = __webpack_public_path__ + "static/media/messageBox-warning.9bcd4975.svg";